<div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Talent Preview</h3>
    <button mat-icon-button class="close-btn" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>


<mat-dialog-content class="dialog-scroll-wrapper"
    style="background-color: rgb(247, 248, 250);scrollbar-width:none !important;margin: 0px !important;">

    <div *ngIf="previewLoader" class="custom-loader custom_logo_loader ">
        <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
    </div>

    <div class="job-details-page" *ngIf="!previewLoader">
        <div class="job-details-page__container">
            <!-- Main Content -->
            <main class="job-details-content">
                <!-- ...existing code... -->

                <!-- Job Header START -->
                <div class="job-header-new">
                    <div class="job-header-new__left">

                        <!-- <ng-container *ngIf="!data?.post_anonymously; else showPlaceholder">

                            <div class="job-header-logo">
                                <img *ngIf="data?.profile_image?.length > 0 && data.profile_image[0]?.url; else noImage"
                                    [src]="data.profile_image[0]?.url" class="company-logo" />
                            </div>

                            <ng-template #noImage>
                                <div class="job-header-logo" style="background-color: #ccc;"></div>
                            </ng-template>

                        </ng-container> -->

                        <ng-container *ngIf="!data?.post_anonymously; else showPlaceholder">

                            <div class="job-header-logo">
                                <ng-container
                                    *ngIf="data?.profile_image?.length > 0 && data.profile_image[0]?.url; else noImage">
                                    <img [src]="data.profile_image[0].url" class="company-logo" />
                                </ng-container>
                            </div>

                            <ng-template #noImage>
                                <div class="job-header-logo" style="background-color: #ccc;"></div>
                            </ng-template>

                        </ng-container>


                        <ng-template #showPlaceholder>
                            <ng-container *ngIf="data?.post_anonymously">
                                <img class="talent-avatars"
                                    *ngIf="data?.dental_professional?.gender === 'male'; else femalePlaceholder"
                                    src="../../../../../../../assets/images/social/male_avatar.png " />
                                <ng-template #femalePlaceholder>
                                    <img class="talent-avatars"
                                        *ngIf="data?.dental_professional?.gender === 'female'; else defaultPlaceholder"
                                        src="../../../../../../../assets/images/social/female_avatar.png" />
                                </ng-template>

                            </ng-container>
                        </ng-template>

                        <div>
                            <div *ngIf="data?.full_name && !data?.post_anonymously" class="job-header-new__label">Name
                            </div>
                            <div *ngIf="data?.full_name && !data?.post_anonymously" class="job-header-new__title">{{
                                data?.full_name }}</div>
                            <div *ngIf="data?.job_designation" class="job-header-new__label">Designation</div>
                            <div *ngIf="data?.job_designation" class="job-header-new__company">{{
                                data?.job_designation}}</div>

                            <!-- <div class="job-info-new__value" *ngIf="data?.work_type?.length">
                                    <span class="job-header-new__badge" *ngFor="let type of data?.work_type">{{ type
                                        }}</span>
                                
                                </div> -->

                        </div>
                    </div>
                    <div class="job-header-new__right">
                        <div style="margin-bottom: 11px;width: 100%;margin-right: 20px;">
                            <div class="job-header-new__date" *ngIf="data?.Year_of_experiance">Experience: {{
                                data?.Year_of_experiance }} Years</div>
                        </div>
                        <div class="job-header-new__apply-button">
<!-- 
                            <button class="job-header-new__viewcv"
                                *ngIf="data?.upload_resume && data.upload_resume.length > 0 && data.upload_resume[0].url"
                                (click)="viewDocument(data.upload_resume[0])">
                                View CV
                            </button> -->


                               <button class="job-header-new__viewcv"
                *ngIf="data?.upload_resume && data?.upload_resume.length > 0 && data?.upload_resume[0].url"
                (click)="viewDocument(data?.upload_resume[0])">
                View CV
              </button>

                        </div>
                    </div>
                </div>
                <hr class="job-header-new__divider" />

                <!-- others -->
                <div class="personalData">

                    <div *ngIf="data?.profession_type">
                        <div class="job-header-new__label">Profession Type</div>
                        <div *ngIf="data?.profession_type" class="job-header-new__company">{{
                            data?.profession_type}}</div>

                    </div>

                    <div *ngIf="data?.current_company">

                        <div class="job-header-new__label">Current Company</div>
                        <div *ngIf="data?.current_company" class="job-header-new__company">{{
                            data?.current_company}}</div>
                    </div>


                    <div *ngIf="data?.email_address">

                        <div class="job-header-new__label">Email Address</div>
                        <div *ngIf="data?.profession_type" class="job-header-new__company">{{
                            data?.email_address}}</div>
                    </div>
                    <div *ngIf="data?.mobile_number">
                        <div class="job-header-new__label">Mobile Number</div>
                        <div *ngIf="data?.mobile_number" class="job-header-new__company">{{
                            data?.mobile_number}}</div>
                    </div>

                    <div *ngIf="data?.aphra_number">

                        <div class="job-header-new__label">Aphra Registration Number</div>
                        <div *ngIf="data?.aphra_number" class="job-header-new__company">{{
                            data?.aphra_number}}</div>

                    </div>


                    <div *ngIf="data?.abn_number">

                        <div class="job-header-new__label">ABN Number</div>
                        <div *ngIf="data?.abn_number" class="job-header-new__company">{{
                            data?.abn_number}}</div>
                    </div>

                    <!-- <div *ngIf="data?.radius">

                        <div class="job-header-new__label">Radius</div>
                        <div *ngIf="data?.radius" class="job-header-new__company">{{
                            data?.radius}}</div>
                    </div> -->

                    <div *ngIf="data?.willing_to_travel">
                        <div class="job-header-new__label"> Willing to Travel</div>
                        <div *ngIf="data?.willing_to_travel" class="job-header-new__company"> Yes </div>
                    </div>

                    <div *ngIf="data?.travel_distance">
                        <div class="job-header-new__label">Travel Distance</div>
                        <div *ngIf="data?.travel_distance" class="job-header-new__company">{{
                            data?.travel_distance}} km</div>
                    </div>


                    <div *ngIf="data?.work_rights">
                        <div class="job-header-new__label">Work Rights</div>
                        <div *ngIf="data?.work_rights" class="job-header-new__company">{{
                            data?.work_rights}}</div>
                    </div>


                    <div *ngIf="data?.percentage">

                        <div class="job-header-new__label">Percentage</div>
                        <div *ngIf="data?.percentage" class="job-header-new__company">{{
                            data?.percentage}} %</div>
                    </div>



                    <div *ngIf="data?.salary_amount">

                        <div class="job-header-new__label">Salary Amount</div>
                        <div *ngIf="data?.salary_amount" class="job-header-new__company">{{
                            data?.salary_amount}}</div>
                    </div>

                    <div *ngIf="data?.salary_type">

                        <div class="job-header-new__label">Salary Type</div>
                        <div *ngIf="data?.salary_type" class="job-header-new__company">{{
                            data?.salary_type}} </div>
                    </div>


                    <!-- <div *ngIf="data?.availabilityType">
                        <div class="job-header-new__label">Availability Type</div>
                        <div *ngIf="data?.availabilityType" class="job-header-new__company">{{
                            data?.availabilityType}}</div>
                    </div> -->

                    <!-- <div *ngIf="data?.availabilityDate?.length || data?.availabilityDay?.length">
                        <p class="job-header-new__label">Available On:</p>
                        <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 4px;">

                            <span *ngFor="let date of data.availabilityDate"
                                style="display: flex; align-items: center;">
                                <span style="font-size: 14px;">•</span>
                                <span class="job-header-new__company" style="margin-left: 4px;">{{ date | date: 'dd MMM
                                    yyyy' }}</span>
                            </span>


                            <span *ngFor="let day of data.availabilityDay" style="display: flex; align-items: center;">
                                <span style="font-size: 14px;">•</span>
                                <span class="job-header-new__company" style="margin-left: 4px;">{{ day }}</span>
                            </span>
                        </div>
                    </div> -->

                </div>


                <hr class="job-header-new__divider" />

                <div class="personalData">

                   
                    <div *ngIf="data?.availabilityOption">
                        <div class="job-header-new__label">Available <span *ngIf="data?.availabilityOption === 'fromDate1'"> from</span>
                        </div>
                    
                        <div *ngIf="data?.availabilityOption === 'immediate1'" class="job-header-new__company">
                            Immediately
                        </div>
                    
                        <div *ngIf="data?.fromDate && data?.availabilityOption ==='fromDate1'">
                            <ul class="availability-list">
                                <!-- Dates -->
                                <li class="job-header-new__company">
                                    {{ data?.fromDate | date: 'dd MMM yyyy' }}
                                </li>
                    
                            </ul>
                        </div>
                    
                    </div>

                </div>


                <hr *ngIf="data?.fromDate?.length || data?.availabilityOption " class="job-header-new__divider" />

                <div class="personalData">

                    <!-- <div *ngIf="data?.availabilityType">
                        <div class="job-header-new__label">Availability Type</div>
                        <div class="job-header-new__company">
                            {{
                            data.availabilityType === 'fromDate'
                            ? 'FromDate'
                            : data.availabilityType === 'fromDay'
                            ? 'FromDay'
                            : data.availabilityType
                            }}
                        </div>
                    </div> -->


                    <div *ngIf="data?.availabilityDate?.length || data?.availabilityDay?.length">
                        <p class="job-header-new__label">Available Days</p>
                        <ul class="availability-list">
                            <!-- Dates -->
                            <li class="job-header-new__company" *ngFor="let date of visibleDates">
                                {{ date | date: 'dd MMM yyyy' }}
                            </li>

                            <li *ngIf="data?.availabilityDate?.length > 5" style="color: #0b87ba !important;"  class="desc-see-more" (click)="showMoreDates = !showMoreDates">
                                {{ showMoreDates ? 'See Less' : 'See More' }}
                            </li>

                            <!-- Days -->
                            <li class="job-header-new__company" *ngFor="let day of visibleDays">
                                {{ day | slice:0:3 }}
                            </li>

                            <li *ngIf="data?.availabilityDay?.length > 5" style="color: #0b87ba !important;" class="desc-see-more" (click)="showMoreDays = !showMoreDays">
                                {{ showMoreDays ? 'See Less' : 'See More' }}
                            </li>

                        </ul>
                    </div>
                   

                </div>



                <!-- <hr  class="job-header-new__divider" /> -->

                <!-- skills -->
                <div class="job-info-new"
                    *ngIf="data?.work_type?.length || data?.skills?.length || data?.languages_spoken?.length || data?.areas_expertise?.length"
                    style="padding: 20px !important;margin-top: 30px;">
                    <div class="job-header-new__badges" style="flex-direction: column;gap: 20px;">
                        <div class="job-info-new__item" *ngIf="data?.work_type?.length">
                            <div class="job-info-new__label">Work Type</div>
                            <div class="job-info-new__value">
                                <span class="job-header-new__badge" *ngFor="let type of data?.work_type">{{ type
                                    }}</span>

                            </div>
                        </div>
                        <div class="job-info-new__item" *ngIf="data?.skills?.length">
                            <div class="job-info-new__label">Skills</div>
                            <div class="job-info-new__value">
                                <span class="job-header-new__badge" *ngFor="let type of data?.skills">{{ type
                                    }}</span>

                            </div>
                        </div>
                        <div class="job-info-new__item" *ngIf="data?.languages_spoken?.length">
                            <div class="job-info-new__label">Language</div>
                            <div class="job-info-new__value">
                                <span class="job-header-new__badge" *ngFor="let type of data?.languages_spoken">{{ type
                                    }}</span>

                            </div>
                        </div>

                        <div class="job-info-new__item" *ngIf="data?.areas_expertise?.length">
                            <div class="job-info-new__label">Areas of Expertise</div>
                            <div class="job-info-new__value">
                                <span class="job-header-new__badge" *ngFor="let type of data?.areas_expertise">{{ type
                                    }}</span>

                            </div>
                        </div>


                        <!-- <div class="job-info-new__item" *ngIf="data?.areas_expertise?.length">
                            <div class="job-info-new__label">Areas of Expertise</div>
                            <div class="job-info-new__value">
                                <span class="job-header-new__badge" *ngFor="let type of data?.areas_expertise">{{ type
                                    }}</span>

                            </div>
                        </div> -->


                    </div>
                </div>

                <!-- Replace your current .job-info block with this -->
                <!-- about -->
                <div *ngIf="data?.about_yourself" class="job-info-new" style="background-color: transparent;">
                    <div class="job-info-new__item job-info-new__item--full-width">
                        <div class="job-info-new__label">About me</div>

                        <!-- <div class="job-info-new__value">{{ data?.about_yourself }}</div> -->
                        <p class="about-yourself" >
                            {{ showFull ? data?.about_yourself : (data?.about_yourself | slice:0:150) }}{{ data?.about_yourself.length > 150 && !showFull ? '...'
                            : '' }}
                            <span *ngIf="data?.about_yourself.length > 150" (click)="toggleDescription()" class="desc-see-more">
                                {{ showFull ? 'See Less' : 'See More' }}
                            </span>
                        </p>
                    </div>

                </div>
                <hr *ngIf="data?.about_yourself" class="job-header-new__divider" />

                <!-- <div class="job-info-new" *ngIf="data?.about_yourself" style="background-color: transparent;">
              <div class="job-info-new__item job-info-new__item--full-width">
                <div class="job-info-new__label">Key Responsibilities / Intrest</div>
                <div class="job-info-new__value">{{ data?.about_yourself }}</div>
              </div>
    
    
            </div>
            <hr class="job-header-new__divider" *ngIf="data?.about_yourself" /> -->

                <!-- education -->

                <div class="job-info-new" *ngIf="data?.educations?.length" style="background-color: transparent;">
                    <div class="job-header-new__badges">
                        <div class="job-info-new__item">
                            <div class="job-info-new__label">Education</div>
                            <div class="job-info-new__value" *ngFor="let type of data?.educations">{{
                                type.qualification}}-{{ type.finishDate | date: 'yyyy' }}
                            </div>
                        </div>

                    </div>
                </div>
                <hr class="job-header-new__divider" *ngIf="data?.educations?.length" />

                <!-- Others -->

                <!-- <div class="job-info-new" style="background-color: transparent;">
                    <div class="job-info-new__item job-info-new__item--full-width">
                        <div class="job-info-new__label">Other Info</div>
                        <div class="job-info-new__value">{{ data?.abn_number }}</div>
                        <div class="job-info-new__value">{{ data?.aphra_number }}</div>
                        <div class="job-info-new__value">{{ data?.areas_expertise }}</div>
                        <div class="job-info-new__value">{{ data?.current_company }}</div>
                        <div class="job-info-new__value">{{ data?.current_ctc }}</div>
                        <div class="job-info-new__value">{{ data?.current_company }}</div>
                        <div class="job-info-new__value">{{ data?.current_company }}</div>
                    </div>

                </div>
                <hr class="job-header-new__divider" /> -->

                <!-- experience -->

                <div class="job-info-new" *ngIf="data?.jobexperiences?.length"
                    style="background-color: transparent;padding:5px 0 0 5px !important">
                    <div class="job-info-new__item job-info-new__item--full-width">
                        <div class="job-info-new__label">Work Experience</div>
                    </div>
                </div>
                <mat-accordion multi="true" *ngIf="data?.jobexperiences?.length" style="border-radius: 15px;">
                    <ng-container *ngFor="let exp of data.jobexperiences; let i = index">
                        <mat-expansion-panel class="custom-expansion-panel" style="margin-bottom: 0px !important">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="job-info-new__expyear">
                                        <div class="job-info-new__value" style="font-weight: 500;"><span>{{
                                                exp.job_title
                                                }}</span>at<span>{{ exp.company_name }}</span></div>
                                    </div>

                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <!-- <div><strong>{{ exp.job_title }}</strong> at <strong>{{ exp.company_name }}</strong></div> -->
                            <div style="font-weight: 500;font-size: 14px; margin-bottom: 5px">
                                {{ exp.startMonth }} {{ exp.startYear }} -
                                {{ exp.stillInRole ? 'Present' : (exp.endMonth + ' ' + exp.endYear) }}
                            </div>
                            <div class="job-info-new__expdescription">{{ exp.ejobdesp }}</div>
                        </mat-expansion-panel>

                        <!-- This line will always be visible -->
                        <hr class="job-header-new__divider" *ngIf="i < data.jobexperiences.length - 1"
                            style="margin: 0px !important;border: 1px solid #D3D7DB" />
                    </ng-container>
                </mat-accordion>

                <hr *ngIf="data?.jobexperiences?.length" class="job-header-new__divider" />

                <!-- <div class="job-info-new" *ngIf="data?.location" style="background-color: transparent;">
                    <div class="job-info-new__item job-info-new__item--full-width">
                        <div class="job-info-new__label">Current Location</div>
                        <div class="job-info-new__value">{{ data?.location }}</div>
                    </div>
    
                </div> -->

                <div class="job-location" *ngIf="data?.location" style="position: relative;margin-top: 15px;">
                    <div>
                        <div class="heading">Job Location</div>
                        <p>{{ data?.location }}</p>
                    </div>
                    <div class="viewmap">
                        <img src="assets/images/social/MapImage.png" alt=""
                            style="width:100%; height:100%; object-fit:cover;">
                        <button type="button" class="view-map-btn" (click)="openMap()">View on map</button>
                    </div>

                    <div class="map-popup" *ngIf="showMap" (click)="onOutsideClick($event)">
                        <div class="map-content" (click)="$event.stopPropagation()">
                            <div id="map"></div>
                        </div>
                    </div>

                </div>

                <hr *ngIf="data?.location" class="job-header-new__divider" />

                <div class="custom-documents">
                    <!-- certificate -->
                    <!-- <div class="job-info-new" *ngIf="data?.certificate?.length" style="background-color: transparent;">
                        <div class="job-header-new__badges">
                            <div class="job-info-new__item">
                                <div class="job-info-new__label" style="margin-bottom: 10px;">Certifications</div>
                                <div class="job-info-new__value file-preview-list">
                                    <div class="file-preview-item" *ngFor="let type of data?.certificate;let i = index">
                                       
                                        <img *ngIf="['jpg', 'jpeg', 'png', 'webp', 'jfif'].includes(type.extension)"
                                            [src]="type.url" class="file-icon" alt="Image Preview" />

                                        <img *ngIf="type.extension === 'pdf'" src="assets/images/file_icons/pdf.svg"
                                            class="file-icon" alt="PDF" />

                                    
                                        <img *ngIf="type.extension === 'doc' || type.extension === 'docx'"
                                            src="assets/images/file_icons/doc.svg" class="file-icon" alt="Word" />

                                       
                                        <img *ngIf="!['jpg', 'jpeg', 'png', 'webp', 'pdf', 'doc', 'docx', 'jfif'].includes(type.extension)"
                                            src="assets/images/file_icons/file.svg" class="file-icon" alt="File" />

                                        <div class="file-name">{{ type.name }}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> -->
                    <!-- Resume -->
                    <!-- <div class="job-info-new" *ngIf="data?.upload_resume?.length"
                        style="background-color: transparent;">
                        <div class="job-header-new__badges">
                            <div class="job-info-new__item">
                                <div class="job-info-new__label" style="margin-bottom: 10px;">Uploaded Resume</div>
                                <div class="job-info-new__value file-preview-list">
                                    <div class="file-preview-item"
                                        *ngFor="let file of data.upload_resume; let i = index">
                                        <img *ngIf="['jpg','jpeg','png','webp','jfif'].includes(file.extension)"
                                            [src]="file.url" class="file-icon" alt="Image Preview" />

                                        <img *ngIf="file.extension === 'pdf'" src="assets/images/file_icons/pdf.svg"
                                            class="file-icon" alt="PDF" />

                                        <img *ngIf="file.extension === 'doc' || file.extension === 'docx'"
                                            src="assets/images/file_icons/doc.svg" class="file-icon" alt="Word" />

                                        <img *ngIf="!['jpg','jpeg','png','webp','pdf','doc','docx','jfif'].includes(file.extension)"
                                            src="assets/images/file_icons/file.svg" class="file-icon" alt="File" />

                                        <div class="file-name">{{ file.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <!-- Cover Letter -->
                    <!-- <div class="job-info-new" *ngIf="data?.cover_letter?.length" style="background-color: transparent;">
                        <div class="job-header-new__badges">
                            <div class="job-info-new__item">
                                <div class="job-info-new__label" style="margin-bottom: 10px;">Cover Letter</div>
                                <div class="job-info-new__value file-preview-list">
                                    <div class="file-preview-item"
                                        *ngFor="let file of data.cover_letter; let i = index">
                                       
                                        <img *ngIf="['jpg','jpeg','png','webp','jfif'].includes(file.extension)"
                                            [src]="file.url" class="file-icon" alt="Image Preview" />

                                      
                                        <img *ngIf="file.extension === 'pdf'" src="assets/images/file_icons/pdf.svg"
                                            class="file-icon" alt="PDF" />

                                        <img *ngIf="file.extension === 'doc' || file.extension === 'docx'"
                                            src="assets/images/file_icons/doc.svg" class="file-icon" alt="Word" />

                                       
                                        <img *ngIf="!['jpg','jpeg','png','webp','pdf','doc','docx','jfif'].includes(file.extension)"
                                            src="assets/images/file_icons/file.svg" class="file-icon" alt="File" />

                                        <div class="file-name">{{ file.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="uploaded-documents">
                        <div *ngIf="data.certificate?.length">
                            <h5>Certificates</h5>
                            <div class="document-row">
                                <!-- <div class="document-row" [ngClass]="
                                data.upload_resume.length > 0 && data.cover_letter.length > 0 ? '' : 'five-cols'
                              "> -->

                                <div class="document-item" *ngFor="let file of data?.certificate; let i = index"
                                    [matTooltip]="file.name" matTooltipClass="doc-tooltip">

                                    <div (click)="feeddocumentView(file)">
                                        <!-- Image Preview -->
                                        <img *ngIf="file.extension === 'jpg' || file.extension === 'jpeg' || file.extension === 'png' || file.extension === 'webp'"
                                            [src]="file.url" class="file-icon" />

                                        <!-- PDF Icon -->
                                        <img *ngIf="file.extension === 'pdf'" src="assets/images/file_icons/pdf.svg"
                                            class="file-icon" />

                                        <!-- Word Icon -->
                                        <img *ngIf="file.extension === 'doc' || file.extension === 'docx'"
                                            src="assets/images/file_icons/doc.svg" class="file-icon" />

                                        <span class="file-name">{{ file.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div *ngIf="data.upload_resume?.length">
                            <h5>Resume</h5>
                            <div class="document-row">
                                <div class="document-item" *ngFor="let file of data?.upload_resume; let i = index"
                                    [matTooltip]="file.name" matTooltipClass="doc-tooltip">

                                    <div (click)="feeddocumentView(file)">
                                        <img *ngIf="file.extension === 'jpg' || file.extension === 'jpeg' || file.extension === 'png' || file.extension === 'webp'"
                                            [src]="file.url" class="file-icon" />

                                        <img *ngIf="file.extension === 'pdf'" src="assets/images/file_icons/pdf.svg"
                                            class="file-icon" />

                                        <img *ngIf="file.extension === 'doc' || file.extension === 'docx'"
                                            src="assets/images/file_icons/doc.svg" class="file-icon" />

                                        <span class="file-name">{{ file.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->


                        <div *ngIf="data.cover_letter?.length">
                            <h5>Cover Letter</h5>
                            <div class="document-row">
                                <div class="document-item" *ngFor="let file of data?.cover_letter; let i = index"
                                    [matTooltip]="file.name" matTooltipClass="doc-tooltip">

                                    <div (click)="feeddocumentView(file)">
                                        <!-- Image Preview -->
                                        <img *ngIf="file.extension === 'jpg' || file.extension === 'jpeg' || file.extension === 'png' || file.extension === 'webp'"
                                            [src]="file.url" class="file-icon" />

                                        <!-- PDF Icon -->
                                        <img *ngIf="file.extension === 'pdf'" src="assets/images/file_icons/pdf.svg"
                                            class="file-icon" />

                                        <!-- Word Icon -->
                                        <img *ngIf="file.extension === 'doc' || file.extension === 'docx'"
                                            src="assets/images/file_icons/doc.svg" class="file-icon" />

                                        <span class="file-name">{{ file.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>


                <div>

                </div>

            </main>

        </div>
    </div>

</mat-dialog-content>